import { useQuery } from '@tanstack/react-query';
import { Form, type FormInstance } from 'antd';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import { TableDefault } from '@/components/antd/TableDefault';
import { apiProdutoAlteracaoPrecoGet } from '@/features/produto/api/apiProdutoAlteracaoPrecoGet';
import { ProdutoTipoAlteracao } from '@/features/produto/types/ProdutoAlteracaoPreco';
import { usePagination } from '@/std/pagination/usePagination';
import { useSyncPaginationTotal } from '@/std/pagination/useSyncPaginationTotal';
import { ProdutoTabKeyHistoricoAlteracao } from '../useProdutoTabItems';
import { produtoTabHistoricoAlteracaoColumns } from './produtoTabHistoricoAlteracaoColumns';

export function ProdutoTabHistoricoAlteracaoCusto({
    form,
    tab2,
}: {
    form: FormInstance<FormProdutoValues>;
    tab2: ProdutoTabKeyHistoricoAlteracao;
}) {
    const { params, onTableChange, tablePagination, updateTotalAndPagination } = usePagination();

    const tipo = ProdutoTipoAlteracao.PrecoCusto.toString();

    const pro_idpk = Form.useWatch('pro_idpk', form);

    const { data, isFetching } = useQuery({
        enabled: !!pro_idpk && tab2 === ProdutoTabKeyHistoricoAlteracao.PrecoCusto,
        queryFn: () =>
            apiProdutoAlteracaoPrecoGet({
                ...params,
                orderby: params.orderby ?? 'alp_data_insercao desc',
                tipo,
                where: `alp_produto_idpk = ${pro_idpk}`,
            }),
        queryKey: ['apiProdutoAlteracaoPrecoGet', tipo, params, pro_idpk],
    });

    useSyncPaginationTotal(updateTotalAndPagination, data?.total_registros);

    return (
        <div className='flex flex-col gap-2 p-5'>
            <TableDefault
                columns={produtoTabHistoricoAlteracaoColumns}
                dataSource={data?.registros}
                loading={isFetching}
                onChange={onTableChange}
                pagination={tablePagination}
                rowKey='alp_idpk'
            />
        </div>
    );
}
